import React from "react";
import {NavLink} from "react-router-dom";
import ContentBox from "../../../../../../../components/content-box/ContentBox";
import PageActions from "../../../../../../base/PageActions";
import Breadcrumbs from "../../../../../../../components/breadcrumbs/Breadcrumbs";
import _image_service from "../../../../../../../services/ImageService";
import '../../../../../../styles/Common.scss';
import '../../../WorldPages.scss';
import '../MagicItemsPage.scss';

interface MagicAmuletPageProps {
}

const MagicAmuletPage = (props: MagicAmuletPageProps) => {

    const page: PageActions = new PageActions({
        title: `Casarok: Magic Amulets - Chase the Fox`,
        description: "Amulets are wearable magic items that can enhance the magical power of its user in Casarok!",
        keywords: ["casarok", "magic", "magic compendium", "magic item", "magical", "magical item", "magic amulet", "magic pendant", "magic shard"],
        imgSrc: `chase/world/magic/items/amulet.png`,
        url: `world/magic/items/amulet`
    });

    return page.generateMetaContent(
        <>
            <ContentBox header="Amulets">
                <Breadcrumbs path={page.getUrl()}/>
                <div className="world-page-static">
                    <img className="magic-item-pic right"
                         src={_image_service.getCdnImageSrc(`chase/world/magic/items/amulet.png`)}
                         alt="A green pendant with a red rune inside"
                         title="Chase's magic pendant, one type of amulet"/>
                    <p>
                        Amulets are wearable magic items that enhance the magical power of its user in a variety of ways
                        depending on the enchantments placed upon them. They can do anything from improve the user's
                        power in a <NavLink className="world-link" to="/world/magic/schools">school</NavLink> or a
                        single <NavLink className="world-link" to="/world/magic/elements">element</NavLink>, reduce the
                        mana cost of such spells, provide additional effects on spells, or even provide access to spells
                        that one would not normally have access to. The requirements for using the amulet are also at
                        the will of the enchanter or crafter. They could be as simple as wearing them, require the
                        user to be soulbound to it, or even require the user to constantly expend their will or mana
                        to tap into its potential.
                    </p>
                    <p>
                        Because of their flexibility, amulets come in a variety of forms. Pictured above, for example,
                        is the pendant worn by <NavLink className="world-link" to="/characters/chase">Chase</NavLink>,
                        which provides him access to a plethora of shapeshifting abilities. This particular one is
                        magically bound to holder's body such that any attempt to cast a shapeshifting spell affects the
                        user instead.
                    </p>
                    <p>
                        Several notable figures
                        in <NavLink className="world-link" to="/comics/talechasers">Tale Chasers</NavLink> utilize
                        different amulets other than Chase.
                    </p>
                </div>
            </ContentBox>
        </>
    );
}

export default MagicAmuletPage;